var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
    This file is generated with the "identicons" script.
    To update this output make changes to `scripts/svgr/identicon-icon-template.js
    */
import * as React from "react";
import { IdenticonsCustomProperty, useColorMap } from "../common";
export var IdenticonHelp = function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    var colorMap = useColorMap({
        color: color,
    });
    var fills = {
        light: "var(" + IdenticonsCustomProperty.light + ", " + colorMap.light + ")",
        base: "var(" + IdenticonsCustomProperty.base + ", " + colorMap.base + ")",
        dark: "var(" + IdenticonsCustomProperty.dark + ", " + colorMap.dark + ")",
    };
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M24.011 4.028A19.986 19.986 0 1023.964 44a19.986 19.986 0 00.047-39.972zm0 29.967a10.005 10.005 0 110-20.01 10.005 10.005 0 010 20.01z", fill: fills.light }),
        React.createElement("path", { d: "M6.194 14.975l8.898 4.52a9.888 9.888 0 014.402-4.426l-4.45-8.922a20.056 20.056 0 00-8.85 8.828zM15.09 41.857l4.473-8.898a9.981 9.981 0 01-4.473-4.45l-8.946 4.45a20.056 20.056 0 008.946 8.898zM41.855 32.959l-8.921-4.45a10.051 10.051 0 01-4.426 4.426l4.52 8.875a20.056 20.056 0 008.827-8.851zM32.98 6.146l-4.425 8.946a9.817 9.817 0 014.402 4.449l8.898-4.496a19.916 19.916 0 00-8.874-8.899z", fill: fills.dark })));
};
